import React from 'react';
import { Swipeable } from 'react-swipeable';

let isTouchDevice;
if (process.env.NODE_ENV !== 'test') {
  isTouchDevice = require('utils/isTouchDevice').default();
}

export default class Instruments extends React.Component {
  state = {
    prevIndex: 0,
    containerWidth: 0,
    currentPos: 0,
    delta: 0,
  };

  constructor(props, context) {
    super(props, context);

    this.handleScrollLeft = this.handleScrollLeft.bind(this);
    this.handleScrollRight = this.handleScrollRight.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleJumpLeft = this.handleJumpLeft.bind(this);
    this.handleJumpRight = this.handleJumpRight.bind(this);
  }

  componentDidMount() {
    this.calculateDimensions();
  }

  calculateTimeout = null;
  componentDidUpdate(prevProps) {
    const { count } = React.Children;
    if (count(prevProps.children) !== count(this.props.children)) {
      if (this.calculateTimeout) {
        clearTimeout(this.calculateTimeout);
      }

      this.calculateTimeout = setTimeout(() => {
        this.calculateDimensions();
      }, 50);
    }

    if (!!this.props.addItem && prevProps.addItem !== this.props.addItem) {
      const currentPos = this.calculateWithinBounds(
        this.state.containerWidth - this.state.totalWidth,
      );
      this.setState({ currentPos });
    }
  }

  calculateDimensions() {
    const wrapper = this.refs.list;
    const widths = Array.from(wrapper?.children || []).map(
      node => node.offsetWidth,
    );

    var totalWidth = widths.reduce((sum, width) => sum + width, 0);

    this.setState({
      containerWidth: this.refs.container.offsetWidth,
      itemWidth: totalWidth / wrapper.children.length,
      totalWidth,
    });
  }

  addResistance(delta) {
    return delta * (1 - parseInt(Math.sqrt(Math.pow(delta, 2)), 10) / 1000);
  }

  handleScroll(_, delta, deltaY, isFlick) {
    const { currentPos } = this.state;
    // Accelerate delta if flicked
    if (isFlick) {
      delta = delta * 1.7;
    }

    let newPos = currentPos + (0 - delta);
    newPos = this.calculateWithinBounds(newPos);

    this.setState({
      delta: 0,
      currentPos: newPos,
    });
  }

  calculateWithinBounds(value) {
    const { containerWidth, totalWidth } = this.state;
    const leftBound = 0;
    const rightBound = 0 - Math.max(0, totalWidth - containerWidth);

    value = Math.min(value, leftBound);
    value = Math.max(value, rightBound);

    return value;
  }

  handleScrollLeft(e, delta) {
    this.setState({
      delta: this.addResistance(delta),
    });
  }

  handleScrollRight(e, delta) {
    this.setState({ delta: 0 - this.addResistance(delta) });
  }

  handleJumpLeft() {
    const { itemWidth, currentPos } = this.state;
    const position = this.calculateWithinBounds(currentPos + itemWidth);

    this.setState({ currentPos: position });
  }

  handleJumpRight() {
    const { itemWidth, currentPos } = this.state;

    const position = this.calculateWithinBounds(currentPos - itemWidth);
    this.setState({ currentPos: position });
  }

  render() {
    const { currentPos, delta, totalWidth } = this.state;
    const transition = 'all 250ms ease-out';
    return (
      <div className="Instruments" ref="container">
        <Swipeable
          ref="swipable"
          onSwipingRight={this.handleScrollLeft}
          onSwipingLeft={this.handleScrollRight}
          onSwiped={this.handleScroll}
          style={{
            transform: 'translate3d(' + (delta + currentPos) + 'px, 0, 0)',
            transition: delta === 0 ? transition : 'none',
            width: totalWidth,
          }}
        >
          <ul ref="list">{this.props.children}</ul>
        </Swipeable>
        {!isTouchDevice && (
          <nav className="controls">
            <button
              className="next"
              aria-label="Navigate right"
              onClick={this.handleJumpRight}
            >
              <i className="fa fa-angle-right" />
            </button>
            <button
              className="prev"
              aria-label="Navigate left"
              onClick={this.handleJumpLeft}
            >
              <i className="fa fa-angle-left" />
            </button>
          </nav>
        )}
      </div>
    );
  }
}
